import axios from 'axios';
import { getAuthHeaders, createAction, toQueryString } from '../../utils/utils';

export const LOAD = '[Ceofence] LOAD';
export function load() {
  return { type: LOAD };
}

export const LOAD_SUCCESS = '[Ceofence] LOAD_SUCCESS';
export function loadSuccess(data) {
  return { type: LOAD_SUCCESS, data };
}

export const LOAD_FAILED = '[Ceofence] LOAD_FAILED';
export function loadFailed(error) {
  return { type: LOAD_FAILED, error };
}
export const LOAD_ONE = '[Ceofence] LOAD_ONE';
export function loadOne() {
  return { type: LOAD_ONE };
}

export const LOAD_SUCCESS_ONE = '[Ceofence] LOAD_SUCCESS_ONE';
export function loadSuccessOne(data) {
  return { type: LOAD_SUCCESS_ONE, data };
}

export const LOAD_FAILED_ONE = '[Ceofence] LOAD_FAILED_ONE';
export function loadFailedOne(error) {
  return { type: LOAD_FAILED_ONE, error };
}

export const EXPORT = '[File] EXPORT';
export function exportFile() {
  return { type: EXPORT };
}

export const EXPORT_SUCCESS = '[File] EXPORT_SUCCESS';
export function exportSuccess(file) {
  return { type: EXPORT_SUCCESS, file };
}

export const EXPORT_FAIL = '[File] EXPORT_FAIL';
export function exportFailed(error) {
  return { type: EXPORT_FAIL, error };
}

export const VOID = '[Ceofence] VOID';
export function emptyRequirement() {
  return { type: VOID };
}

export const UPDATE_ONE = '[Ceofence] UPDATE_ONE';
export function updateOne(data) {
  return { type: UPDATE_ONE, data };
}

export const UPDATE_ONE_FAILED = '[Ceofence] UPDATE_ONE_FAILED';
export function updateOneFailed(error, id) {
  return { type: UPDATE_ONE_FAILED, error, id };
}

export const UPDATE_ONE_SUCCESS = '[Ceofence] UPDATE_ONE_SUCCESS';
export function updateOneSucess(data) {
  return { type: UPDATE_ONE_SUCCESS, data };
}

export const CREATE = '[Ceofence] CREATE';
export function create(data) {
  return { type: UPDATE_ONE, data };
}

export const CREATE_SUCCESS = '[Ceofence] CREATE_SUCCESS';
export function createSuccess(data) {
  return { type: CREATE_SUCCESS, data };
}

export const CREATE_FAILED = '[Ceofence] CREATE_FAILED';
export function createFailed(error) {
  return { type: CREATE_FAILED, error };
}

export const DESTROY = '[Ceofence] DESTROY';
export function destroy(data) {
  return { type: DESTROY, data };
}

export const DESTROY_SUCCESS = '[Ceofence] DESTROY_SUCCESS';
export function destroySuccess(id) {
  return { type: DESTROY_SUCCESS, id };
}

export const DESTROY_FAILED = '[Ceofence] DESTROY_FAILED';
export function destroyFailed(error) {
  return { type: DESTROY_FAILED, error };
}

export function fetchAll(rut) {
  return async function (dispatch, getState) {
    dispatch(load());

    try {
    //   let url = `${window.config.API_URL_USER}ceofence`;
    const url = `${window.config.API_URL_USER}ceofence?rut=${rut}`;

    //   if (Object.keys(filters).length) {
    //     url = `${url}?${toQueryString(filters)}`;
    //   }

      const res = await axios.get(url, {
        headers: getAuthHeaders(getState())
      });

      if (res.status === 201) {
        dispatch(loadSuccess(res.data.data));
      } else {
        dispatch(loadFailed(res.data.message));
      }
    } catch (err) {
      dispatch(loadFailed(err));
    }
  };
}

// export function fetchUpdateOne(id, rolName) {
//   return async function (dispatch, getState) {
//     dispatch(loadOne());

//     try {
//       const url = `${window.config.API_URL_USER}alarm/getUpdateOne?id=${id}&rolName=${rolName}`;

//       const res = await axios.get(url, {
//         headers: getAuthHeaders(getState())
//       });

//       if (res.status === 201) {
//         dispatch(loadSuccessOne(res.data.data));
//       } else {
//         dispatch(loadFailedOne(res.data.message));
//       }
//     } catch (err) {
//       dispatch(loadFailedOne(err));
//     }
//   };
// }

// export function exportFile(type = '', SistemaId) {
//   // console.log('SistemaId');
//   return async function (dispatch) {
//     dispatch(exportFleet());

//     try {
//       let url = `${window.config.API_URL_ABASTIBLE}trucks/export`;

//       if (Object.keys(type).length) {
//         url = `${url}?${toQueryString(type)}&SistemaId=${SistemaId}`;
//       }

//       const res = await axios.get(url, {
//         headers: {
//           // Authorization: 'Bearer'
//         }
//       });

//       if (res.status === 200) {
//         saveAs(res.config.url, `Flotas`);

//         dispatch(exportSuccess(res.data.data));
//       } else {
//         dispatch(exportFailed(res.error));
//       }
//     } catch (error) {
//       dispatch(exportFailed(error));
//     }
//   };
// }

export function updateById(data) {
  return async function (dispatch, getState) {
    dispatch(updateOne(data));

    try {
      const res = await axios.put(`${window.config.API_URL_USER}ceofence/${data.id}`, data, {
        headers: getAuthHeaders(getState())
      });

      if (res.status === 201) {
        dispatch(updateOneSucess(res.data.data));
      } else {
        dispatch(updateOneFailed(res, data.id));
      }
    } catch (error) {
      console.log('error:', error);
      dispatch(updateOneFailed(error, data.id));
    }
  };
}

export function createData(data) {
  return async function (dispatch, getState) {
    dispatch(create(data));
    try {
      const res = await axios.post(`${window.config.API_URL_USER}ceofence`, data, {
        headers: getAuthHeaders(getState())
      });

      if (res.status === 201) {
        dispatch(createSuccess(res.data.data));

        // axios.get(`${window.config.API_URL_SCHEDULER}email-scheduler?ForecastId=${res.data.data.id}`, {
        //   headers: getAuthHeaders(getState())
        // });
      } else {
        dispatch(createFailed(res));
      }
    } catch (error) {
      console.log('error:', error);
      dispatch(createFailed(error));
    }
  };
}

export function destroyById(id) {
  return async function (dispatch, getState) {
    dispatch(destroy(id));

    try {
      const res = await axios.delete(`${window.config.API_URL_USER}ceofence/${id}`, {
        headers: getAuthHeaders(getState())
      });

      if (res.status === 201) {
        dispatch(destroySuccess(id));
      } else {
        dispatch(destroyFailed(res, id));
      }
    } catch (error) {
      console.log('error:', error);
      dispatch(destroyFailed(error, id));
    }
  };
}
